
import { initializeEncryption } from "../../services/AesGcmEncryption";
import * as CONSTANT from "../../constants/Constant";

import { Box } from "@mui/material";
import {useTheme } from "@mui/material";
import { tokens } from "../../theme";
import GreetingHeader from "../../components/GreetingHeader";
import SectionHeader from "../../components/SectionHeader";
import CustomButton from "../../components/CustomButton";
import UserActivityInfo from "../../components/UserActivity";
import Grid from "@mui/material/Unstable_Grid2";
import HighlightStats from "../../components/HighlightStats";
import * as React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import ConnectionStatus from "../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import {
  getFromLocalStorage,
  saveToLocalStorageJsonObject,
} from "../../utils/localStorageUtils";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import { useAtom } from "jotai";
import {
  globalSearchText,
  isAuthPageAtom,
  showErrorAlertDialog,
} from "../../config/AppConfig";
import {
  ALERT,
  ERROR_WHILE_FETCHING_DATA,
  NO_INTERNET_CONNECTION_FOUND,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
  FETCHING_ON_HOLD_SUMMARY_PLEASE_WAIT,
  ERROR,
} from "../../constants/Strings";
import DebugLog from "../../utils/DebugLog";
import {
  LOGIN_ID,
  MESSAGE_KEY,
  NAV_ONHOLD_DETAILS,
  SESSION_ID,
  USER_ROLE,
  USER_NAME,
} from "../../constants/LocalStorageKeyValuePairString";
import {
  generateRandomId,
  generateRequestId,
} from "../../utils/RequestIdGenerator";
import {
  getOnHoldHeaderSummary,
  getPayoutActivityDetails,
} from "../../services/ApiService";
import { useNavigate } from "react-router-dom";

import NoDataFound from "../../components/NoDataFound";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import CancelHoldDialog from "./CancelHoldDialog";
import { formatPrice } from "../../utils/PriceFormatter";
import useAxiosHookV2 from "../../hooks/UseAxiosV2";
import { onHoldColumnHeader } from "./OnHoldListItemsHeader";

export function OnHoldSummary() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();
  const [userRole, setUserRole] = useState([]);

  const isNetworkConnectionAvailable = UseOnlineStatus();

  const [, setAuthStatus] = useAtom(isAuthPageAtom);
  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);

  const [getProgressbarText, setProgressbarText] = useState("");

  const [openDialog, setOpenDialog] = useState(false);

  const [onHoldHeaderSummary, setOnHoldHeaderSummary] = useState([]);
  const [onHoldData, setOnHoldData] = useState([]);
  const [onHoldActivityDetails, setOnHoldActivityDetails] = useState([]);

  const [gridHeight, setGridHeight] = useState(500); // Default height
  const [totalNoOfRows, setTotalNoOfRows] = useState(0); // Default height
  const [pageSize, setPageSize] = useState(15);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchQuery, setSearchQuery] = useAtom(globalSearchText);
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [nbRows, setNbRows] = React.useState(3);

  // Activity Details
  const [selectedDateRange, setSelectedDateRange] = useState(
    CONSTANT.ACTIVITY_PERIODS.THREE_MONTHS
  );

  // pagination for Activity
  const [activityPageSize, setActivityPageSize] = useState(15);
  const [activityCurrentPage, setActivityCurrentPage] = useState(0);
  const [activityTotalNoOfPages, setActivityTotalNoOfPages] = useState(0);

  const { data, apiCallError, showProgressBar, fetchData } = useAxiosHookV2();
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [currentFirstColumn, setCurrentFirstColumn] = useState("payoutCycleCount");
  const [columns, setColumns] = React.useState(onHoldColumnHeader);
  

  useEffect(() => {
    getUserRole();
    getOnHoldData();
  }, []);

  useEffect(() => {
    getHeaderSummary();
    getActivityDetails(activityCurrentPage, selectedDateRange);
  }, []);

  useEffect(() => {
    getDataGridHeight();

    showNoInternetSnackBar();

    navigate(blockNavigation);
  }, [isNetworkConnectionAvailable, enqueueSnackbar, navigate, totalNoOfRows]);

  useEffect(() => {
    if (showProgressBar) {
      setProgressbarText(FETCHING_ON_HOLD_SUMMARY_PLEASE_WAIT);
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [showProgressBar]);

  // increase - decrease list layout height on available list itmes count
  function getDataGridHeight() {
    // Calculate the total height required for the grid
    const headerHeight = 60; // Height of header row
    const rowHeight = 60; // Height of each data row
    let rowCount = 0;
    if (totalNoOfRows <= pageSize) {
      rowCount = totalNoOfRows; // Total number of data rows
    } else {
      rowCount = pageSize; // Total number of data rows
    }

    const totalHeight = headerHeight + rowCount * rowHeight;

    // Set the grid height
    setGridHeight(totalHeight);
  }

  useEffect(() => {
    if (apiCallError) {
      if(apiCallError.message!==null && apiCallError.message==="Network Error"){
        showErrorAlert(
          ERROR,
          apiCallError.message
        );
      }
      else
        if (apiCallError.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
          alert(apiCallError.data.displayErrorMessage)
          navigate(CONSTANT.LOGIN)
        }else{
        const message =
        apiCallError.data !== null ? apiCallError.data.displayErrorMessage : apiCallError.message;
        showErrorAlert(
          ERROR,
          ERROR_WHILE_FETCHING_DATA+ JSON.stringify(message)
        );
        }
      
    }
  }, [apiCallError]);

  // useEffect(() => {
  //   if (apiCallError) {
  //     if (
  //       apiCallError.data != null &&
  //       apiCallError.data.responseCode != null &&
  //       apiCallError.data.responseCode != "-1"
  //     ) {
  //       const message =
  //         apiCallError.response != null
  //           ? apiCallError.response
  //           : apiCallError.message;
  //       showErrorAlert(
  //         apiCallError.message,
  //         ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
  //       );
  //     } else {
  //       const message =
  //         apiCallError.data != null
  //           ? apiCallError.data.displayErrorMessage
  //           : apiCallError.message;
  //       showErrorAlert(
  //         ERROR,
  //         ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
  //       );
  //     }
  //   }
  // }, [apiCallError]);

  const handleDateRangeChange = (selectedDateRange) => {
    setSelectedDateRange(selectedDateRange);
    getActivityDetails(activityCurrentPage, selectedDateRange);
  };

  const handleActivityPageChange = (newPage) => {
    setActivityCurrentPage(newPage);
    getActivityDetails(newPage, selectedDateRange);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    DebugLog("Dialog Closed");
  };
  const swapColumns = () => {
    setColumns((prevColumns) => {
      const newColumns = [...prevColumns];
      [newColumns[2], newColumns[3]] = [newColumns[3], newColumns[2]];
      setCurrentFirstColumn(newColumns[2].field);
      //DebugLog("newColumns[3]>>>" + JSON.stringify(newColumns[3].field));
      return newColumns;
    });
  };

  function getUserRole() {
    setUserRole(getFromLocalStorage(USER_ROLE));
  }

  const handleSelectionChange = (newSelection) => {
    setSelectedRows(newSelection);
  };

  const resetSelection = () => {
    setSelectedRows([]);
  };
  const handleRowClick = (params) => {
    //{"companyCode":"A0002","pageNumber":0,"endDate":"2023-07-31","pageSize":100,"startDate":"2023-07-01"}

    const pageNumber = 0;
    const pageSize = 100;
    const onHoldRowSelected = {
      companyCode: params.row.companyCode,
      startDate: params.row.startDate,
      endDate: params.row.endDate,
      pageNumber: pageNumber,
      pageSize: pageSize,
      companyName: params.row.companyName,
    };

    DebugLog("onHoldRowSelected  " + JSON.stringify(onHoldRowSelected));
    saveToLocalStorageJsonObject(NAV_ONHOLD_DETAILS, onHoldRowSelected);
    navigate(CONSTANT.ON_HOLD_DETAILS_ROUTE, { data: onHoldRowSelected });
  };

  /******* API Calls *********/
  async function getHeaderSummary() {
    try {
      if (!isNetworkConnectionAvailable) {
        throw new Error(NO_INTERNET_CONNECTION_FOUND);
      }
      setProgressbarText(FETCHING_ON_HOLD_SUMMARY_PLEASE_WAIT);
      //setLoading(true); // Hide the progress dialog

      const contentData = {};

      const encryptedContentData = await initializeEncryption(
        contentData,
        getFromLocalStorage(MESSAGE_KEY),
        ApiType.ON_HOLD_HEADER_SUMMARY
      );

      const requestData = {
        requestId: generateRequestId(),
        loginId: getFromLocalStorage(LOGIN_ID),
        sessionId: getFromLocalStorage(SESSION_ID),
        loginUserName: getFromLocalStorage(USER_NAME),
        contentData: encryptedContentData,
      };

      getOnHoldHeaderSummary(requestData)
        .then((response) => {
          //DebugLog("onHoldHeaderSummary response: " + JSON.stringify(response));
          setOnHoldHeaderSummary(response.data.result);
          //setLoading(false);
        })
        .catch((error) => {
          handleError(error);
        });
    } catch (error) {
      handleError(error);
    }
  }

  async function getOnHoldData() {
    try {
      if (isNetworkConnectionAvailable) {
        // setOnHoldLoading(false);
        const requestObject = {
          // loginUserId: getFromLocalStorage(USER_ID),
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_HOLD_PAYOUT_COUNT_SUMMARY
        ).then((encryptedContentData) => {
          fetchData(
            process.env.REACT_APP_DASHBOARD_ON_PAYAOUT_COUNT_SUMMARY_API_URL,
            ApiType.GET_HOLD_PAYOUT_COUNT_SUMMARY,
            ApiType.POST_METHOD,
            encryptedContentData,
            {},
            (data) => {
              if (data !== null) {
                const rowsWithIds = data.result.map((row) => ({
                  ...row,
                  id: generateRandomId(),
                }));

                setOnHoldData(rowsWithIds);
                //setOnHoldLoading(false);
              }
            }
          );
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  }

  function getActivityDetails(pageNo, passedDateRange) {
    try {
      if (isNetworkConnectionAvailable) {
        // setProgressbarText(LOADING_PLEASE_WAIT);
        // setLoading(true);

        const toDate = new Date();
        let fromDate = new Date();

        let numberOfMonth = 3;

        switch (passedDateRange) {
          case CONSTANT.ACTIVITY_PERIODS.THREE_MONTHS:
            numberOfMonth = 3;
            fromDate.setMonth(toDate.getMonth() - 3);
            break;
          case CONSTANT.ACTIVITY_PERIODS.SIX_MONTHS:
            numberOfMonth = 6;
            fromDate.setMonth(toDate.getMonth() - 6);
            break;
          case CONSTANT.ACTIVITY_PERIODS.ONE_YEAR:
            numberOfMonth = 12;
            fromDate.setFullYear(toDate.getFullYear() - 1);
            break;
          default:
            numberOfMonth = 3;
            fromDate.setMonth(toDate.getMonth() - 3); // default to 3 months if no valid option is selected
        }

        const requestObject = {
          pageNumber: pageNo,
          pageSize: activityPageSize,
          // fromDate: fromDate.toISOString(),
          // toDate: toDate.toISOString(),
          noOfMonth: numberOfMonth,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.GET_PAYOUT_ACTIVITY_DETAILS
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          getPayoutActivityDetails(requestData)
            .then((response) => {
              const contentData = response.data.result.content.map((row) => ({
                ...row,
                id: generateRandomId(),
              }));
              setOnHoldActivityDetails(contentData);
              setActivityTotalNoOfPages(response.data.result.totalPages);
              //setLoading(false);
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }

  const startDownload = () => {
    showErrorAlert("", "COMING SOON!");
    resetSelection();
  };
  function blockNavigation(location, action) {
    // Block navigation if action is "pop", which indicates back/forward button press
    if (action === "pop") {
      // Optionally, you can show a message to the user before blocking navigation
      alert("Back button is disabled.");
      return false;
    }
    return true; // Allow navigation for other actions like "push" or "replace"
  }
  const handlePageSizeChange = (newPageSize) => {
    // Here, you would fetch new data based on the new page size
    // For the sake of this example, let's just set the page size
    // without updating the data
    setPageSize(newPageSize);
    getDataGridHeight();
  };
  function showErrorAlert(title, content) {
    try {
      DebugLog("an error found====" + content);
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  // handle error code reusable block
  function handleError(error) {
    setLoading(false);

    if (error.message === NO_INTERNET_CONNECTION_FOUND) {
      // Handle no internet connection error
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      return;
    }

    const errorCode = error.data?.errorCode;
    var errorMessage =
      error.response != null ? error.displayErrorMessage : "Unknown";
    if (error.data?.displayErrorMessage) {
      errorMessage = error.data.displayErrorMessage;
    }

    const errorActions = {
      [ApiErrorCode.SESSION_EXPIRED]: () => navigate(CONSTANT.LOGIN),
      [ApiErrorCode.SESSION_ID_NOT_FOUND]: () => navigate("/"),
      [ApiErrorCode.UNABLE_TO_PROCESS_ERROR]: () =>
        navigate(CONSTANT.FINANCE_DASHBOARD),
      default: () =>
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(errorMessage)
        ),
    };
    (errorActions[errorCode] || errorActions.default)();
  }

  /****** Navigations *********/
  const handleOnHoldRowClicked = (data) => {
    try {
      if(data.field!=="actions"){
      if (currentFirstColumn === "dealerCount") {
        navigate(CONSTANT.PAYOUT_DEALER_SUMMARY_ROUTE, {
          state: {
            holdType: data.row.type,
            flowFrom: CONSTANT.ON_HOLD_ROUTE,
            flowStartedFrom: CONSTANT.ON_HOLD_ROUTE,
            rootStartPageSelectedColumn: currentFirstColumn,
          },
        });
      } else {
        navigate(CONSTANT.ON_HOLD_PAYOUT_CYCLE_ROUTE, {
          state: {
            holdType: data.row.type,
            flowFrom: CONSTANT.ON_HOLD_ROUTE,
            flowStartedFrom: CONSTANT.ON_HOLD_ROUTE,
            rootStartPageSelectedColumn: currentFirstColumn,
          },
        });
      }
    }
    } catch (e) {
      DebugLog(e + "");
    }
  };

  return (
    /* Main Container */
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />
        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />
        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}
        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            borderRadius: "18px",
          }}
        >
          {/* Greetings Header */}
          <Grid container>
            <Grid item>
              <GreetingHeader name={"On Hold"}></GreetingHeader>
            </Grid>
          </Grid>
          {/* Greetings Header */}

          {/* Highlight Stats */}
          <HighlightStats
            highlightTotal={
              "RM " + formatPrice(onHoldHeaderSummary.totalAmount)
            }
            highlight1={"Device Reimbursement"}
            highlight1Stat={
              "RM " + formatPrice(onHoldHeaderSummary.deviceAmount)
            }
            highlight2={"Incentives"}
            highlight2Stat={
              "RM " + formatPrice(onHoldHeaderSummary.incentiveAmount)
            }
            // highlight3={"Incentives"}
            // highlight3Stat={"RM 31.47"}
          ></HighlightStats>

          {/* On Hold Section */}
          <Grid
            container
            mt={3}
            border={"1px solid" + colors.grey[600]}
            borderRadius={2}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
          >
            <SectionHeader
              // sectionIcon={"../../assets/common/OnHold.svg"}
              sectionIcon={
                <svg
                  width="36"
                  height="36"
                  viewBox="0 0 36 36"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M15.975 28.665V7.335C15.975 5.31 15.12 4.5 12.96 4.5H7.515C5.355 4.5 4.5 5.31 4.5 7.335V28.665C4.5 30.69 5.355 31.5 7.515 31.5H12.96C15.12 31.5 15.975 30.69 15.975 28.665Z"
                    stroke="#292D32"
                    stroke-width="2.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M31.4987 28.665V7.335C31.4987 5.31 30.6437 4.5 28.4837 4.5H23.0387C20.8937 4.5 20.0237 5.31 20.0237 7.335V28.665C20.0237 30.69 20.8787 31.5 23.0387 31.5H28.4837C30.6437 31.5 31.4987 30.69 31.4987 28.665Z"
                    stroke="#292D32"
                    stroke-width="2.25"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              }
              sectionHeading={"On Hold"}
            ></SectionHeader>
            <Box sx={{ width: "100%", padding: 2 }}>
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                {/* <Button onClick={swapColumns}>Swap DEALERS / CYCLES</Button> */}
                <CustomButton
                  btnBG={colors.grey[900]}
                  btnColor={colors.grey[100]}
                  btnStartIcon={
                    <img
                      src="../../assets/common/reorder_icon.svg"
                      width={22}
                    />
                  }
                  btnTxt={"REORDER"}
                  onClick={swapColumns}
                ></CustomButton>
              </Box>
            </Box>

            {/* <OnHoldSummaryTable
              loading={isOnHoldLoading}
              statusData={"On Hold"}
              statusBG={colors.primary[300]}
              data={onHoldData}
              onRowClicked={handleOnHoldRowClicked}
            ></OnHoldSummaryTable> */}

            <Grid
              item
              mb={20}
              border={"1px solid" + colors.grey[600]}
              borderRadius={3}
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              pb={2}
            >
              {onHoldData.length > 0 ? (
                <Box
                  borderRadius={3}
                  flex={1}
                  m="0px 0 0 0"
                  pb={0}
                  height={gridHeight}
                  sx={{
                    "& .MuiDataGrid-root": {
                      border: "none",
                    },
                    "& .MuiDataGrid-cell": {
                      borderBottom: "none",
                    },
                    "& .name-column--cell": {
                      color: colors.redAccent[200],
                      fontWeight: "bold",
                      fontSize: 13,
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      backgroundColor: "rgba(255,255,255,0.6)",
                      borderBottom: "none",
                      fontWeight: "bold",
                      fontSize: "13px",
                      color: `${colors.grey[300]} !important`,
                    },
                    "& .MuiDataGrid-virtualScroller": {
                      background: "rgba(255,255,255,1)",
                    },
                    "& .MuiDataGrid-footerContainer": {
                      borderTop: "none",
                      backgroundColor: "rgba(255,255,255,0.6)",
                    },
                    "& .MuiCheckbox-root": {
                      //color: `${colors.white[200]} !important`,
                    },
                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                      color: `${colors.grey[300]} !important`,
                      // backgroundColor: "rgba(255,255,255,0.6)",
                      // opacity:.5
                    },
                  }}
                >
                  <DataGrid
                    classes={{ row: "dataGridRow" }}
                    rows={onHoldData}
                    columns={columns}
                    components={{ Toolbar: GridToolbar }}
                    pageSize={pageSize}
                    rowCount={totalNoOfRows}
                    onCellClick={handleOnHoldRowClicked}
                    rowsPerPageOptions={[15, 30, 45, 60]}
                    autoHeight
                  />
                </Box>
              ) : (
                NoDataFound()
              )}
            </Grid>
          </Grid>

          {/* On Hold Section */}

          {/* activity list */}
          <Grid container mt={15}>
            <UserActivityInfo
              type={"Payouts"}
              data={onHoldActivityDetails}
              ondateRangeChange={handleDateRangeChange}
              totalNoOfPages={activityTotalNoOfPages}
              onPageChange={handleActivityPageChange}
            />
            {/* activity list */}
          </Grid>
        </Grid>

        <CancelHoldDialog open={openDialog} onClose={handleCloseDialog} />
      </SnackbarProvider>
    </Box>
    /* Main Container */
  );
}
